import React from "react";
import { useHistory } from "react-router-dom";
import { ArrowRight, Car, UtensilsCrossed } from "lucide-react";

const LIVE_PILLARS = [
  { label: "Work", color: "#017bef" },
  { label: "Stay", color: "#0062c0" },
  { label: "Play", color: "#0ea5e9" },
];

const UPCOMING = [
  {
    label: "Move",
    color: "#0062c0",
    icon: Car,
    image: "/figma-assets/home/roadmap-move.jpg",
    // The Move photo sits above the gradient in the design
    gradient: false,
    launch: "Coming soon — Launching Q4 2026",
    title: "Get where you need to go.",
    description:
      "Get where you need to go, with trusted car rental from accredited providers booked directly through SPACIA.",
    detail:
      "Move brings car rental onto the SPACIA platform, connecting you with accredited rental companies for every stage of your journey — from the airport to your next meeting, hotel or weekend adventure.",
    to: "/move",
  },
  {
    label: "Eat",
    color: "#0ea5e9",
    icon: UtensilsCrossed,
    image: "/figma-assets/home/roadmap-eat.jpg",
    gradient: true,
    launch: "Coming soon — Launching 2027",
    title: "Order food from anywhere.",
    description:
      "Order food from your favourite restaurants, delivered, packed for pickup, or sent straight to your destination of choice — all through the SPACIA app.",
    detail:
      "Eat brings restaurant ordering and delivery onto the SPACIA platform, so ordering a meal feels as effortless as booking a desk, a stay or a spa appointment.",
    to: "/eat",
  },
];

const Plus = () => <span className="text-[16px] font-light leading-6 text-[#e5e7eb]">+</span>;

export default function RoadmapSection() {
  const history = useHistory();

  return (
    <section className="bg-white py-20">
      <div className="mx-auto max-w-[1440px] px-[16px] sm:px-8">
        <p className="text-[14px] font-semibold uppercase leading-5 tracking-[1.4px] text-[#017bef]">What's Next</p>
        <h2 className="max-w-[672px] pt-[12px] text-[36px] font-bold leading-[1.2] tracking-[-1.2px] text-[#0a0a0a] sm:text-[48px] sm:leading-[48px]">
          More Ways to Move Through Your Day
        </h2>

        <div className="flex flex-wrap items-center gap-[12px] pt-12">
          {LIVE_PILLARS.map(pillar => (
            <React.Fragment key={pillar.label}>
              <span
                className="rounded-full px-[16px] py-2 text-[14px] font-semibold leading-5 text-white"
                style={{ backgroundColor: pillar.color }}
              >
                {pillar.label}
              </span>
              <Plus />
            </React.Fragment>
          ))}
          <span className="rounded-full border-[1px] border-dashed border-[#e5e7eb] bg-[#f5f8ff] px-[16px] py-2 text-[14px] font-semibold leading-5 text-[#9ca3af]">
            Move · Soon
          </span>
          <Plus />
          <span className="rounded-full border-[1px] border-dashed border-[#e5e7eb] bg-[#f5f8ff] px-[16px] py-2 text-[14px] font-semibold leading-5 text-[#9ca3af]">
            Eat · Soon
          </span>
        </div>

        <div className="grid grid-cols-1 gap-6 pt-12 md:grid-cols-2">
          {UPCOMING.map(({ icon: Icon, ...item }) => (
            <div
              key={item.label}
              className="overflow-hidden rounded-3xl border-[1px] border-solid border-[#e5e7eb] bg-[#f8fbff]"
            >
              <div className="relative h-52">
                <img src={item.image} alt={item.label} className="absolute inset-0 size-full object-cover" />
                {item.gradient && (
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
                )}
                <div className="absolute left-[16px] top-[16px] flex items-center gap-2">
                  <span
                    className="rounded-full px-[12px] py-1 text-[12px] font-bold uppercase leading-4 tracking-[1.2px] text-white"
                    style={{ backgroundColor: item.color }}
                  >
                    {item.label}
                  </span>
                  <span className="rounded-full border-[1px] border-solid border-white/15 bg-[rgba(10,10,10,0.6)] px-[12px] py-1 text-[12px] font-semibold leading-4 text-white">
                    Coming Soon
                  </span>
                </div>
                <div className="absolute bottom-[16px] right-[16px] flex size-12 items-center justify-center rounded-2xl border-[1px] border-solid border-white/20 bg-white/15">
                  <Icon className="size-7 text-white" />
                </div>
              </div>
              <div className="p-7">
                <p
                  className="text-[12px] font-semibold uppercase leading-4 tracking-[1.2px]"
                  style={{ color: item.color }}
                >
                  {item.launch}
                </p>
                <h3 className="pt-[12px] text-[20px] font-bold leading-[27.5px] text-[#0a0a0a]">{item.title}</h3>
                <p className="pt-[12px] text-[14px] leading-[22.75px] text-[#717182]">{item.description}</p>
                <p className="my-6 border-l-2 border-solid border-[#e5e7eb] pl-[18px] text-[14px] leading-[22.75px] text-[#717182]">
                  {item.detail}
                </p>
                <button
                  type="button"
                  onClick={() => history.push(item.to)}
                  className="inline-flex items-center gap-2 text-[14px] font-semibold leading-5 text-[#717182] opacity-60 transition-opacity hover:opacity-100"
                >
                  {/* The design says "Get notified when it launches", but there is no waitlist yet */}
                  Learn more
                  <ArrowRight className="size-3.5" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
